/*
	支払方法管理画面
	定期購読支払い詳細情報表示画面
*/

import React, { memo } from 'react';
import classes from './subscription-detail.module.scss';
import { findPaymentByKey, findPaymentTypeValueByKey, isCredit, isPayPal } from 'consts/PaymentConst';
import { PeriodicPaymentDetailToken } from 'requests/RequestPeriodicPayment';

type Props = {
	periodicPaymentToken: PeriodicPaymentDetailToken;
};
export const SubscriptionDetail = memo((props: Props) => {
	const { periodicPaymentToken } = props;

	const isInvalidDate = (date: Date) => {
		return Number.isNaN(date.getTime());
	};

	const paymentType = findPaymentByKey(Number(periodicPaymentToken?.payment_type));
	return (
		<>
			<div className="section-head">
				<span>定期購読の情報</span>
			</div>
			<div className={classes.subscriptionInfo}>
				<div className={`info-box ${classes.subscriptionInfoBox}`}>
					<div className="info-head width50">サービス名</div>
					<div className="info-text width50">
						<label>{periodicPaymentToken?.site_name}</label>
					</div>
				</div>
				<div className={`info-box ${classes.subscriptionInfoBox}`}>
					<div className="info-head width50">
						<label>支払方法</label>
					</div>
					<div className="info-text width50">
						<label>{findPaymentTypeValueByKey(Number(periodicPaymentToken?.payment_type))}</label>
					</div>
				</div>

				<div className={`info-box ${classes.subscriptionInfoBox}`}>
					<div className="info-head width50">
						<label>支払方法詳細</label>
					</div>
					{isCredit(paymentType) ? (
						<div>
							<div className={'info-text'}>
								<label>{periodicPaymentToken.brand}</label>
							</div>
							<div className={`info-text ${classes.subscriptionPaymentDetail}`}>
								<label>{`**** **** **** ${periodicPaymentToken.last_digits}`}</label>
							</div>
							<div className={`info-text ${classes.subscriptionPaymentDetail}`}>
								<label>{periodicPaymentToken.expiry}</label>
							</div>
						</div>
					) : isPayPal(paymentType) ? (
						<div className={`info-text`}>
							<label>{periodicPaymentToken.paypal_email}</label>
						</div>
					) : null}
				</div>
				<div className={`info-box ${classes.subscriptionInfoBox}`}>
					<div className="info-head width50">
						<label>初回決済日</label>
					</div>
					<div className="info-text width50">
						<label>
							{!isInvalidDate(periodicPaymentToken.first_capture_date)
								? periodicPaymentToken.first_capture_date?.toLocaleDateString()
								: ''}
						</label>
					</div>
				</div>

				<div className={`info-box ${classes.subscriptionInfoBox}`}>
					<div className="info-head width50">
						<label>最新決済日</label>
					</div>
					<div className="info-text width50">
						<label>
							{!isInvalidDate(periodicPaymentToken.last_capture_date)
								? periodicPaymentToken.last_capture_date?.toLocaleDateString()
								: ''}
						</label>
					</div>
				</div>
			</div>
		</>
	);
});
